import { motion } from "framer-motion";
import { Snowflake, BatteryCharging, Usb, Info } from "lucide-react";

const CHIPS = [
    { icon: Snowflake, label: "Cold Compress + Fan" },
    { icon: BatteryCharging, label: "3600mAh" },
    { icon: Usb, label: "Type-C Charging" },
];

export default function CoolingTech() {
    return (
        <section id="cooling" data-testid="cooling-tech-section" className="relative py-24 md:py-32 overflow-hidden">
            <div className="spotlight absolute inset-0 opacity-70" />
            <div className="relative max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -48 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-6"
                >
                    <div className="relative rounded-[2rem] overflow-hidden border border-white/10 shadow-[0_40px_120px_-30px_rgba(0,229,255,0.3)]">
                        <img
                            src="/images/fan-cooling-tech.jpeg"
                            alt="Inside the IcePlate cooling system — cold compress plate and fan"
                            className="w-full h-auto object-cover"
                            loading="lazy"
                            data-testid="cooling-tech-image"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 48 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-6"
                >
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-300 mb-3">Advanced cooling technology</p>
                    <h2 className="font-display uppercase font-700 tracking-tighter text-4xl md:text-6xl leading-[0.95]" data-testid="cooling-tech-headline">
                        3 seconds<br />to <span className="text-cyan-300">ice.</span>
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed max-w-md">
                        The IcePlate editions pair the fan with a metal cold-compress plate that chills in about three seconds. Fan for the air, plate for your skin — a dual cooling effect no ordinary mini fan can match.
                    </p>

                    <div className="mt-8 flex flex-wrap gap-3" data-testid="cooling-tech-chips">
                        {CHIPS.map(({ icon: Icon, label }) => (
                            <span key={label} className="flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-4 py-2 text-xs uppercase tracking-[0.15em] text-zinc-300">
                                <Icon className="w-4 h-4 text-cyan-300" /> {label}
                            </span>
                        ))}
                    </div>

                    <div className="mt-8 flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-4 max-w-md" data-testid="cooling-tech-note">
                        <Info className="w-4 h-4 text-cyan-300 mt-0.5 shrink-0" />
                        <p className="text-xs text-zinc-500 leading-relaxed">
                            Good to know: the cooling-plate mode pauses while the fan is charging, and switches back on the moment you unplug.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
